var map = {
	"./alexandru-david.jpg": 8861,
	"./andrea-bellomia.jpg": 9101,
	"./bajram-hushi.jpg": 6786,
	"./carlo-vassallo.jpg": 1070,
	"./davide-cerato.jpg": 8466,
	"./kristian-notari.jpg": 1129,
	"./lorenzo-beccaro.jpg": 5216,
	"./michael-andolino.jpg": 4932,
	"./valerio-buzzelli.jpg": 8078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6751;